import { Row, Col } from "antd";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { PrimaryButton } from "../../styled/Button.styled";
import { useGetRiderByIdQuery } from "../../../feature/user/userApiSlice";
import UserDetailsForm from "./UserDetailsForm";


function UserDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { data, isLoading, isError } = useGetRiderByIdQuery(id)
  const onClose = () => {
    const urlParams = new URLSearchParams(location.search);
    const page = urlParams.get('page') || '1';
    navigate(`/users?page=${page}`);
  };

  return (
    <>
      <Row justify="end" gutter={20} className="button-bottom-margin">
        <Col>
          <PrimaryButton onClick={onClose}>Back</PrimaryButton>
        </Col>
      </Row>
      {!isError && !isLoading && data && (
        <UserDetailsForm data={data} />
      )}
    </>
  );
}
export default UserDetails